import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface SmallBodyTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
  className?: string
}

export const SmallBodyText: FC<SmallBodyTextProps> = ({ children, className = '', ...rest }) => (
  <p className={`small-body-text ${className}`} {...rest}>
    {children}
  </p>
)
